module.exports = __webpack_public_path__ + "static/media/download.d4878b0d.png";